<template>
	<div class="body-container " :class="addressModal ? 'modal-open' : ''">
		<headerNavigation :showLogin="false"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer display-mobile" style="height: 0px;" ></div>
			<div class="div-after-fixed-header" style="height: 103px;"></div>
		</template>
		<div class="site-main-container">
			<div class="page-portal-container container">
				<div class="site-container">
					<userHeader :subMenuIndex="1"></userHeader>
					<div class="comp-settings-contact-information-container">
						<div class="comp-settings-left-nav-container hidden-xs hidden-sm">
							<ul class="left-nav-list list-group aria-parent-nav">
								<li class="left-nav-item list-group-item aria-child-nav aria-left-nav">
									<a href="javascript:void(0)" @click="openPage('user')">
										<span class="left-nav-label pull-left">{{$t('common.accountdetail')}}</span>
										<img src="../../assets/images/right.png" class="left-nav-i dri-arrow-right right-icon"/>
									</a>
								</li>
								<li class="left-nav-item list-group-item aria-child-nav aria-left-nav">
									<a href="javascript:void(0)" @click="openPage('password')">
										<span class="left-nav-label pull-left">{{$t('user.changepassword')}}</span>
										<img src="../../assets/images/right.png" class="left-nav-i dri-arrow-right right-icon"/>
									</a>
								</li>
								<li class="left-nav-item list-group-item aria-child-nav aria-left-nav">
									<a href="javascript:void(0)" class="active-sub-tab">
										<span class="left-nav-label pull-left">{{$t('user.addressbook')}}</span>
										<img src="../../assets/images/right.png" class="left-nav-i dri-arrow-right right-icon"/>
									</a>
								</li>
								<li class="left-nav-item list-group-item aria-child-nav aria-left-nav">
									<a href="javascript:void(0)" @click="openPage('paymethod')">
										<span class="left-nav-label pull-left">{{$t('user.paymentmethod')}}</span>
										<img src="../../assets/images/right.png" class="left-nav-i dri-arrow-right right-icon"/>
									</a>
								</li>
							</ul>
						</div>
						<div class="comp-settings-left-nav-mobile-container hidden-md hidden-lg">
							<div class="left-nav-mobile-container collapse navbar-collapse">
								<ul class="left-nav-ul nav navbar-nav" >
									<li class="left-nav-dropdown dropdown" :class="showSubMenu ? 'open' : ''">
										<a href="javascript:void(0)" class="left-nav-active-page dropdown-toggle" @click="changeSubMenu">
											<span class="left-nav-active-label">{{$t('user.addressbook')}}</span>
											<img src="../../assets/images/arrow-down.png" class="dri-arrow-down dropdown-icon pull-right down-icon"/>
										</a>
										<ul class="left-nav-subnav dropdown-menu">
											<li class="left-nav-links">
												<a href="javascript:void(0)" @click="openPage('user')" class="left-nav-url">{{$t('common.accountdetail')}}</a>
											</li>
											<li class="left-nav-links">
												<a href="javascript:void(0)" @click="openPage('password')" class="left-nav-url">{{$t('user.changepassword')}}</a>
											</li>
											<li class="left-nav-links">
												<a href="javascript:void(0)"  class="left-nav-url">{{$t('user.addressbook')}}</a>
											</li>
											<li class="left-nav-links">
												<a href="javascript:void(0)" @click="openPage('paymethod')" class="left-nav-url">{{$t('user.paymentmethod')}}</a>
											</li>
										</ul>
									</li>
								</ul>
							</div>
						</div>
						<div class="contact-information-container ">
							<div class="woocommerce-MyAccount-content">
								<p>{{$t('address.addresstxt')}}</p>
								<div class="u-columns woocommerce-Addresses col2-set addresses">
									<div class="u-column1 col-1 woocommerce-Address">
										<div class="woocommerce-Address-title title">
											<h2>{{$t('address.billingaddress')}}</h2>
											<p>
												<a class="edit" href="javascript:void(0)" @click="openAddressModal(1)">
													<img src="../../assets/images/edit.png" class="edit-icon"/>
													<br>{{billingAddress.id ? $t('common.edit') : $t('common.add')}} {{$t('address.billingaddress')}}
												</a>
												<br>
												<div class="address-inner">
													<template v-if="!billingAddress.id">{{$t('address.notaddress')}}</template>
													<template v-else>
														{{billingAddress.firstname}}{{billingAddress.lastname}}
														<br>{{billingAddress.companyName}}
														<br>{{billingAddress.address}}
														<br>{{billingAddress.country}}, {{billingAddress.province}} {{billingAddress.city}} {{billingAddress.postalcode}}	
														<br>{{billingAddress.phone}}
														<br>{{billingAddress.email}}
													</template>
												</div>
											</p>
										</div>
									</div>
									<div class="u-column2 col-2 woocommerce-Address">
										<div class="woocommerce-Address-title title">
											<h2>{{$t('address.deliveryaddress')}}</h2>
											<p>
												<a class="edit" href="javascript:void(0)" @click="openAddressModal(2)">
													<img src="../../assets/images/edit.png" class="edit-icon"/>
													<br>{{deliveryAddress.id ? $t('common.edit') : $t('common.add')}} {{$t('address.deliveryaddress')}}
												</a>
												<br>
												<div class="address-inner">
													<template v-if="!deliveryAddress.id">{{$t('address.notaddress')}}</template>
													<template v-else>
														{{deliveryAddress.firstname}}{{deliveryAddress.lastname}}
														<br>{{deliveryAddress.companyName}}
														<br>{{deliveryAddress.address}}
														<br>{{deliveryAddress.country}}, {{deliveryAddress.province}} {{deliveryAddress.city}} {{deliveryAddress.postalcode}}	
														<br>{{deliveryAddress.phone}}
														<br>{{deliveryAddress.email}}
													</template>
												</div>
											</p>
										</div>
									</div>
								</div>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-backdrop fade in" v-if="addressModal"></div>
		<div class="modal fade in" style="display: block;" v-if="addressModal">
			<div class="address-modal modal-dialog">
				<div class="modal-content">
					<div class="modal-main">
						<div class="modal-header">
							<button class="modal-close-btn close close-shipping-modal" @click="closeAddressModal">
								<span>×</span>
							</button>
							<div class="modal-title">
								<h4 class="address-modal-header ng-star-inserted" v-if="addressFlag == 1">{{billingAddress.id ? $t('address.editaddress') : $t('address.addnewaddress')}}</h4>
								<h4 class="address-modal-header ng-star-inserted" v-else>{{deliveryAddress.id ? $t('address.editaddress') : $t('address.addnewaddress')}}</h4>
								<span class="address-form-required-label">*{{$t('common.required')}}</span>
							</div>
						</div>
						<div class="modal-body comp-shipping-address-container">
							<div class="portal-address-book-form-container">
								<div class="comp-address-form-container">
									<div class="shipping-address-form ng-pristine ng-valid ng-touched">
										<div class="company-column site-form-group has-error form-group has-value">
											<label class="site-input-label">*{{$t('login.email')}}:</label>
											<input type="text" v-model="formData.email" :placeholder="$t('tips.pleaseinputemail')" class="site-form-input form-control input-address ng-pristine ng-valid ng-touched"/>
										</div>
										<div style="width: 100%;position: relative;overflow: hidden;">
											<div class="zip-code-column site-form-group form-group has-value">
												<label class="site-input-label">*{{$t('user.firstname')}}:</label>
												<input type="text" v-model="formData.firstname" :placeholder="$t('tips.pleaseinputfirstname')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-valid"/>
											</div>
											<div class="state-column site-form-group form-group has-value">
												<label class="site-input-label">*{{$t('user.lastname')}}:</label>
												<input type="text" v-model="formData.lastname" :placeholder="$t('tips.pleaseinputlastname')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-valid"/>
											</div>
										</div>
										<div class="company-column site-form-group form-group has-value">
											<label class="site-input-label">{{$t('login.companyname')}}:</label>
											<input type="text" v-model="formData.companyName" :placeholder="$t('tips.pleaseinputcompany')" class="site-form-input form-control input-address ng-pristine ng-valid ng-touched"/>
										</div>
										<div class="company-column site-form-group form-group has-value">
											<label class="site-input-label">*{{$t('address.countryregion')}}:</label>
											<div class="site-input-group">
												<div class="site-dropdown dropdown" @click.stop="changeSelectExpand('countryExpandRef')">
													<button class="btn dropdown-toggle">
														<span class="dropdown-toggle-label">{{formData.country ? formData.country : $t('tips.selectanoption')}}</span>
														<img src="../../assets/images/arrow-down.png" class="dropdown-toggle-icon fa fa-angle-down ng-star-inserted down-icon"/>
													</button>
													<ul class="dropdown-menu" :class="openSelect && expandActive == 'countryExpandRef' ? 'ul-expand' : ''">
														<li class="ng-star-inserted" v-for="(item,index) in countryData" :key="index">
															<a href="javascript:void(0)" @click="selectExpand('countryCode','country',item)">
																<span class="dropdown-link-text">{{item.title}}</span>
																<img v-if="formData.countryCode == item.id" src="../../assets/images/check.png" class="check-circle-icon fa fa-check-circle ng-star-inserted check-iocn"/>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
										<div style="width: 100%;position: relative;overflow: hidden;">
											<div class="zip-code-column site-form-group form-group has-value">
												<label class="site-input-label">*{{$t('address.streetaddress')}}:</label>
												<input type="text" v-model="formData.address" :placeholder="$t('tips.pleaseinputstreetaddress')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-valid"/>
											</div>
											<div class="zip-code-column site-form-group form-group has-value">
												<label class="site-input-label">{{$t('address.detailedaddress')}}:</label>
												<input type="text" v-model="formData.remark" :placeholder="$t('tips.pleaseinputaptUnitSuite')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-valid"/>
											</div>
										</div>
										
										<div class="company-column site-form-group form-group has-value">
											<label class="site-input-label">*{{$t('address.city')}}:</label>
											<input type="text" v-model="formData.city" :placeholder="$t('tips.pleaseinputcity')" class="site-form-input form-control input-address ng-pristine ng-valid ng-touched"/>
										</div>
										<div class="company-column site-form-group form-group has-value">
											<label class="site-input-label">*{{$t('address.provinceorregion')}}:</label>
											<div class="site-input-group">
												<div class="site-dropdown dropdown" @click.stop="changeSelectExpand('provinceExpandRef')">
													<button class="btn dropdown-toggle">
														<span class="dropdown-toggle-label">{{formData.province ? formData.province : $t('tips.selectanoption')}}</span>
														<img src="../../assets/images/arrow-down.png" class="dropdown-toggle-icon fa fa-angle-down ng-star-inserted down-icon"/>
													</button>
													<ul class="dropdown-menu" :class="openSelect && expandActive == 'provinceExpandRef' ? 'ul-expand' : ''">
														<li class="ng-star-inserted" v-for="(item,index) in provinceData" :key="index">
															<a href="javascript:void(0)" @click="selectExpand('provinceCode','province',item)">
																<span class="dropdown-link-text">{{item.title}}</span>
																<img v-if="formData.provinceCode == item.id" src="../../assets/images/check.png" class="check-circle-icon fa fa-check-circle ng-star-inserted check-iocn"/>
															</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
										<div style="width: 100%;position: relative;overflow: hidden;">
											<div class="zip-code-column site-form-group form-group has-value">
												<label class="site-input-label">*{{$t('address.zipcode')}}:</label>
												<input type="text" v-model="formData.postalcode" :placeholder="$t('tips.pleaseinputzipcode')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-valid"/>
											</div>
											<div class="zip-code-column site-form-group form-group has-value">
												<label class="site-input-label">*{{$t('address.phone')}}:</label>
												<input type="text" v-model="formData.phone" :placeholder="$t('tips.pleaseinptphone')" class="site-form-input form-control input-address ng-untouched ng-pristine ng-valid"/>
											</div>
										</div>
										
									</div>
								</div>
							</div>
							<button class="site-btn-primary js-end-trap" @click="submitForm">{{$t('common.save')}}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
		<loading v-if="isLoading"></loading>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import userHeader from '../../components/userHeader.vue'
	import loading from '../../components/loading.vue'
	import {getAddressList,queryRegion,addAddress,editAddress} from '../../api/api.js'
	
	export default {
		components: {
			headerNavigation,
			footers,
			userHeader,
			loading
		},
		data() {
			return {
				isMobile:false,
				showSubMenu:false,
				addressModal:false,
				openSelect:false,
				isLoading:false,
				billingAddress:{
					id:'',
					email:'',
					firstname:'',
					lastname:'',
					companyName:'',
					country:'',
					city:'',
					postalcode:'',
					province:'',
					phone:'',
					address:'',
					remark:'',
					provinceCode:'',
					countryCode:''
				},
				deliveryAddress:{
					id:'',
					email:'',
					firstname:'',
					lastname:'',
					companyName:'',
					country:'',
					city:'',
					postalcode:'',
					province:'',
					phone:'',
					address:'',
					remark:'',
					provinceCode:'',
					countryCode:''
				},
				addressFlag:1,//1 账单地址 2 配送地址 3 公用
				formData:{},
				expandActive:'',
				countryCode:'',
				level:1,
				countryData:[],
				provinceData:[]
			};
		},
		mounted() {
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.init()
			this.queryRegion()
		},
		methods: {
			init(){
				var that = this;
				let params = {}
				getAddressList(params).then(res => {
					if (res.code == 200) {
						if(res.data.length > 0){
							res.data.forEach((item) => {
								if(item.type == 1){
									that.billingAddress = item
								}
								if(item.type == 2){
									that.deliveryAddress = item
								}
							})
						}
					}
				})
			},
			queryRegion(){
				var that = this;
				let params = {
					pid:this.countryCode,
					level:this.level
				}
				queryRegion(params).then(res => {
					if (res.code == 200) {
						if(that.level == 1){
							that.countryData = res.data
						}else{
							that.provinceData = res.data
						}
					}
				})
			},
			changeSubMenu(){
				this.showSubMenu = !this.showSubMenu
			},
			openAddressModal(e){
				this.addressFlag = e
				this.formData = e == 2 ? this.deliveryAddress : this.billingAddress
				this.addressModal = true
			},
			closeAddressModal(){
				this.addressModal = false
			},
			changeSelectExpand(element){
				if (this.expandActive == element) {
					this.openSelect = false
					this.expandActive = ''
				}else{
					this.expandActive = element
					this.openSelect = true
				}
			},
			closeSelectExpand(){
				this.openSelect = false
			},
			selectExpand(e,ename,val){
				this.formData[e] = val.id
				this.formData[ename] = val.title
				if(e == 'countryCode'){
					this.countryCode = val.regionid
					this.formData.provinceCode = ''
					this.formData.province = ''
					this.level = 2
					this.queryRegion()
				}
			},
			verification() {
				if(!this.formData.email){
					this.$message.warning(this.$t('tips.pleaseinputemail'));
					return false;
				}
				if(!this.formData.firstname){
					this.$message.warning(this.$t('tips.pleaseinputfirstname'));
					return false;
				}
				if(!this.formData.lastname){
					this.$message.warning(this.$t('tips.pleaseinputlastname'));
					return false;
				}
				if(!this.formData.countryCode){
					this.$message.warning(this.$t('tips.pleaseinputcountryregion'));
					return false;
				}
				if(!this.formData.address){
					this.$message.warning(this.$t('tips.pleaseinputstreetaddress'));
					return false;
				}
				if(!this.formData.city){
					this.$message.warning(this.$t('tips.pleaseinputcity'));
					return false;
				}
				if(!this.formData.provinceCode){
					this.$message.warning(this.$t('tips.pleaseinputprovinceorregion'));
					return false;
				}
				if(!this.formData.postalcode){
					this.$message.warning(this.$t('tips.pleaseinputzipcode'));
					return false;
				}
				if(!this.formData.phone){
					this.$message.warning(this.$t('tips.pleaseinptphone'));
					return false;
				}
				return true;
			},
			confirmAdd(){
				if(this.verification()){
					var that = this;
					let params = {
						type:this.addressFlag,
						email:this.formData.email,
						firstname:this.formData.firstname,
						lastname:this.formData.lastname,
						companyName:this.formData.companyName,
						country:this.formData.country,
						city:this.formData.city,
						postalcode:this.formData.postalcode,
						province:this.formData.province,
						phone:this.formData.phone,
						address:this.formData.address,
						remark:this.formData.remark,
						provinceCode:this.formData.provinceCode,
						countryCode:this.formData.countryCode,
					}
					that.isLoading = true
					addAddress(params).then(res => {
						that.isLoading = false
						if (res.code == 200) {
							that.init()
							that.closeAddressModal()
							that.$message.success(res.msg);
						}else{
							that.$message.warning(res.msg);
							return false;
						}
						
					})
				}
			},
			confirmEdit(){
				if(this.verification()){
					var that = this;
					let params = {
						type:this.addressFlag,
						email:this.formData.email,
						firstname:this.formData.firstname,
						lastname:this.formData.lastname,
						companyName:this.formData.companyName,
						country:this.formData.country,
						city:this.formData.city,
						postalcode:this.formData.postalcode,
						province:this.formData.province,
						phone:this.formData.phone,
						address:this.formData.address,
						remark:this.formData.remark,
						provinceCode:this.formData.provinceCode,
						countryCode:this.formData.countryCode,
						id:this.formData.id
					}
					that.isLoading = true
					editAddress(params).then(res => {
						that.isLoading = false
						if (res.code == 200) {
							that.init()
							that.closeAddressModal()
							that.$message.success(res.msg);
						}else{
							that.$message.warning(res.msg);
							return false;
						}
						
					})
				}
			},
			submitForm(){
				if(this.formData.id){
					this.confirmEdit()
				}else{
					this.confirmAdd()
				}
			}
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/user.css");
	@import url("../../assets/css/address.css");
	.global-header-spacer {
	    height: 50px !important;
	    display: block !important;
	}
</style>